
import React from 'react';
import { Droppable } from '@hello-pangea/dnd';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { PipelineCard } from './PipelineCard';
import type { Candidate } from './types';
import { A2AAgent } from '@/utils/a2a/types';

interface PipelineColumnProps {
  status: string;
  label: string;
  candidates: Candidate[];
  agent?: Partial<A2AAgent>; // Changed to Partial and optional
  onMarkAsHired?: (candidate: Candidate) => void;
}

export const PipelineColumn = ({ 
  status, 
  label, 
  candidates, 
  agent,
  onMarkAsHired 
}: PipelineColumnProps) => {
  return (
    <Card className="min-w-[300px] max-w-[300px] flex-shrink-0">
      <CardHeader className="pb-3">
        <div className="flex items-center justify-between">
          <CardTitle className="text-sm font-medium">{label}</CardTitle>
          <Badge variant="secondary" className="text-xs">
            {candidates.length}
          </Badge>
        </div>
        {agent && agent.name && (
          <div className="text-xs text-muted-foreground">
            AI Agent: {agent.name}
          </div>
        )}
      </CardHeader>
      <CardContent className="pt-0">
        <Droppable droppableId={status}>
          {(provided, snapshot) => (
            <div
              ref={provided.innerRef}
              {...provided.droppableProps}
              className={`min-h-[200px] space-y-2 transition-colors ${
                snapshot.isDraggingOver ? 'bg-accent/50 rounded-md p-2' : ''
              }`}
            >
              {candidates.map((candidate, index) => (
                <PipelineCard
                  key={candidate.id}
                  candidate={candidate}
                  index={index}
                  status={status}
                  onMarkAsHiredRequest={onMarkAsHired}
                />
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </CardContent>
    </Card>
  );
};
